import { NavLink } from 'react-router-dom';
import {
  Compass,
  Link2,
  Trophy,
  BarChart3,
  Heart,
  LineChart,
  Search,
  Bookmark,
  Binoculars,
  Wand2,
  Activity,
  Radar,
  CalendarClock,
} from 'lucide-react';
import clsx from 'clsx';

const NAV = [
  { to: '/keyword-explorer', label: 'Keyword Explorer', icon: Compass },
  { to: '/pin-generator', label: 'Pin Generator', icon: Wand2 },
  { to: '/scheduler', label: 'Scheduler', icon: CalendarClock },
  { to: '/analytics', label: 'Analytics', icon: Activity },
  { to: '/link-explorer', label: 'Link Explorer', icon: Link2 },
  { to: '/top-pins', label: 'Top Pins', icon: Trophy },
  { to: '/pin-stats', label: 'Pin Stats', icon: BarChart3 },
  { to: '/saved-pins', label: 'Saved Pins', icon: Heart },
  { to: '/rank-tracker', label: 'Rank Tracker', icon: LineChart },
  { to: '/search-tracker', label: 'Search Tracker', icon: Search },
  { to: '/saved-keywords', label: 'Saved Keywords', icon: Bookmark },
  { to: '/account-explorer', label: 'Account Explorer', icon: Binoculars },
] as const;

export function Sidebar() {
  return (
    <aside className="flex h-full w-64 flex-col border-r border-ink-800 bg-ink-900">
      <div className="flex h-16 items-center gap-2.5 px-6">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-brand-500 to-accent-400 text-white shadow-glow">
          <Radar className="h-5 w-5" />
        </div>
        <span className="text-lg font-semibold tracking-tight text-white">
          Pin<span className="text-brand-400">Signals</span>
        </span>
      </div>

      <nav className="flex-1 space-y-0.5 px-3 py-4">
        {NAV.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              clsx(
                'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition',
                isActive
                  ? 'bg-brand-500 text-white shadow-glow'
                  : 'text-ink-400 hover:bg-ink-800 hover:text-white',
              )
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-ink-800 px-6 py-4 text-xs text-ink-500">
        Signal, not noise.
      </div>
    </aside>
  );
}
